var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyTickets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.562,
    height: 83.006,
    viewBox: "0 0 91.562 83.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "my_ticket",
    transform: "translate(0 -23.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1980",
    "data-name": "Group 1980",
    transform: "translate(31.19 23.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1979",
    "data-name": "Group 1979"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8442",
    "data-name": "Path 8442",
    d: "M242.14,68.4h-1.8a2.732,2.732,0,1,1,0-5.463h1.8a1.391,1.391,0,0,0,1.391-1.391V53.2a1.391,1.391,0,0,0-1.391-1.391h-1.8a2.735,2.735,0,0,1-2.731-2.731v-.506l2.041-1.87a1.392,1.392,0,0,0,.117-1.931l-5.432-6.339a1.391,1.391,0,0,0-1.962-.151l-1.365,1.17a2.732,2.732,0,1,1-3.555-4.149l1.365-1.17a1.391,1.391,0,0,0,.151-1.962l-5.432-6.339a1.391,1.391,0,0,0-1.962-.151l-1.366,1.17a2.731,2.731,0,0,1-3.851-.3l-1.822-2.126a1.391,1.391,0,0,0-1.962-.151L188.522,44.887H184.55a1.391,1.391,0,0,0,0,2.783h50.277v1.409a5.521,5.521,0,0,0,5.514,5.514h.406v5.565h-.406a5.515,5.515,0,0,0,0,11.029h.406v5.565h-.406a5.52,5.52,0,0,0-5.514,5.514V85.42h-9.621a1.391,1.391,0,1,0,0,2.783h11.012a1.391,1.391,0,0,0,1.391-1.391V82.266a2.734,2.734,0,0,1,2.731-2.731h1.8a1.391,1.391,0,0,0,1.391-1.391V69.795A1.391,1.391,0,0,0,242.14,68.4ZM192.8,44.887,213.332,27.3l.916,1.07a5.514,5.514,0,0,0,7.775.6l.309-.265,3.621,4.226-.309.265a5.514,5.514,0,1,0,7.176,8.375l.309-.265,3.074,3.587H192.8Z",
    transform: "translate(-183.159 -23.941)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1982",
    "data-name": "Group 1982",
    transform: "translate(0 42.678)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1981",
    "data-name": "Group 1981"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8443",
    "data-name": "Path 8443",
    d: "M63.461,178.564H8.7v-1.408a5.521,5.521,0,0,0-5.514-5.514h-.4v-5.565H3.19a5.514,5.514,0,1,0,0-11.029H2.783v-5.565H3.19a5.521,5.521,0,0,0,5.51-5.515v-3.154H24.583a1.392,1.392,0,1,0,0-2.783H7.312a1.391,1.391,0,0,0-1.391,1.391v4.546A2.735,2.735,0,0,1,3.19,146.7H1.39A1.391,1.391,0,0,0,0,148.091v8.348a1.391,1.391,0,0,0,1.391,1.391h1.8a2.731,2.731,0,1,1,0,5.463h-1.8A1.391,1.391,0,0,0,0,164.685v8.348a1.391,1.391,0,0,0,1.391,1.391h1.8a2.735,2.735,0,0,1,2.731,2.731v.752l-1.966,1.559a1.391,1.391,0,0,0-.192,2l5.43,6.334a1.391,1.391,0,0,0,1.962.151l1.366-1.17a2.732,2.732,0,0,1,3.551,4.152l-1.365,1.17a1.391,1.391,0,0,0-.151,1.962l5.431,6.339a1.391,1.391,0,0,0,1.962.151l1.366-1.17a2.731,2.731,0,0,1,3.851.3l1.822,2.126a1.391,1.391,0,0,0,1.962.151l24.013-20.575.038-.036h8.456a1.392,1.392,0,0,0,0-2.783ZM30.2,198.94l-.916-1.069a5.514,5.514,0,0,0-7.775-.6l-.309.265-3.621-4.226.309-.265a5.514,5.514,0,0,0-7.176-8.375l-.309.265-3.074-3.587h43.4Z",
    transform: "translate(0 -138.031)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1984",
    "data-name": "Group 1984",
    transform: "translate(14.049 50.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1983",
    "data-name": "Group 1983"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8444",
    "data-name": "Path 8444",
    d: "M138.648,173.562H100.477a1.392,1.392,0,0,0,0,2.783h36.831v24.7H79.2v-24.7H90.236a1.392,1.392,0,0,0,0-2.783H77.863a1.366,1.366,0,0,0-1.34,1.391V202.44a1.366,1.366,0,0,0,1.34,1.391h60.785a1.366,1.366,0,0,0,1.34-1.391V174.953A1.366,1.366,0,0,0,138.648,173.562Z",
    transform: "translate(-76.523 -173.562)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1986",
    "data-name": "Group 1986",
    transform: "translate(19.751 59.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1985",
    "data-name": "Group 1985"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8445",
    "data-name": "Path 8445",
    d: "M119.191,222.827h-7.684c-.509,0-.745.545-.745,1.054,0,.581.272,1.072.745,1.072h2.671v10.409c0,.491.581.745,1.181.745.581,0,1.181-.254,1.181-.745v-10.41h2.652c.472,0,.745-.509.745-1.072C119.936,223.372,119.7,222.827,119.191,222.827Z",
    transform: "translate(-110.762 -222.827)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1988",
    "data-name": "Group 1988",
    transform: "translate(29.98 59.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1987",
    "data-name": "Group 1987"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8446",
    "data-name": "Path 8446",
    d: "M168.936,222.827c-.6,0-1.181.218-1.181.726v11.808c0,.491.581.745,1.181.745.581,0,1.181-.254,1.181-.745V223.553C170.116,223.045,169.517,222.827,168.936,222.827Z",
    transform: "translate(-167.755 -222.827)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1990",
    "data-name": "Group 1990",
    transform: "translate(34.209 59.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1989",
    "data-name": "Group 1989"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8447",
    "data-name": "Path 8447",
    d: "M199.12,231.454c-.618,0-1.126.182-1.163.745-.055.763-.2,1.944-1.853,1.944-1.253,0-1.944-.672-1.944-2.089v-5.068c0-1.417.69-2.089,1.907-2.089a1.683,1.683,0,0,1,1.889,1.8c.018.545.509.745,1.181.745.8,0,1.181-.218,1.181-1.163,0-2.107-1.8-3.452-4.324-3.452-2.289,0-4.2,1.126-4.2,4.16v5.068c0,3.034,1.889,4.16,4.178,4.16,2.543,0,4.342-1.4,4.342-3.6C200.319,231.69,199.937,231.454,199.12,231.454Z",
    transform: "translate(-191.799 -222.825)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1992",
    "data-name": "Group 1992",
    transform: "translate(44.031 59.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1991",
    "data-name": "Group 1991"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8448",
    "data-name": "Path 8448",
    d: "M255.774,234.6l-3.96-6.031,3.252-4.069a.7.7,0,0,0,.145-.454,1.473,1.473,0,0,0-1.362-1.217.75.75,0,0,0-.654.345l-3.924,5.341v-4.959c0-.509-.6-.726-1.181-.726-.6,0-1.181.218-1.181.726h0v11.808c0,.491.581.745,1.181.745.581,0,1.181-.254,1.181-.745V231.8l.981-1.235,3.415,5.177a.922.922,0,0,0,.817.454,1.438,1.438,0,0,0,1.417-1.181.708.708,0,0,0-.127-.415Z",
    transform: "translate(-246.909 -222.827)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1994",
    "data-name": "Group 1994",
    transform: "translate(53.785 59.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1993",
    "data-name": "Group 1993"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8449",
    "data-name": "Path 8449",
    d: "M309.027,234.035h-5.141v-3.651h2.761a.822.822,0,0,0,.745-.908c0-.491-.272-.945-.745-.945h-2.761V224.9h5.141c.472,0,.745-.491.745-1.054,0-.49-.236-1.017-.745-1.017H302.56c-.527,0-1.035.254-1.035.745v11.79c0,.491.509.745,1.035.745h6.467c.509,0,.745-.527.745-1.017C309.772,234.525,309.5,234.035,309.027,234.035Z",
    transform: "translate(-301.525 -222.826)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1996",
    "data-name": "Group 1996",
    transform: "translate(62.272 59.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1995",
    "data-name": "Group 1995"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8450",
    "data-name": "Path 8450",
    d: "M357.645,222.827h-7.684c-.509,0-.745.545-.745,1.054,0,.581.272,1.072.745,1.072h2.67v10.409c0,.491.581.745,1.181.745.581,0,1.181-.254,1.181-.745v-10.41h2.652c.472,0,.745-.509.745-1.072C358.39,223.372,358.154,222.827,357.645,222.827Z",
    transform: "translate(-349.216 -222.827)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTickets);
export default __webpack_public_path__ + "static/media/my_tickets.6f9ac08f72bf2891a99d44dbd567dc55.svg";
export { ForwardRef as ReactComponent };